import _omit from "lodash/omit";
var _excluded = ["children", "disableScroll", "className", "zIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useState, useEffect, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { containerStyle } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var BodyOverflow = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      disableScroll = props.disableScroll,
      className = props.className,
      _props$zIndex = props.zIndex,
      zIndex = _props$zIndex === void 0 ? 200 : _props$zIndex,
      restProps = _objectWithoutProperties(props, _excluded);

  var containerId = useRef(parseInt(Math.random() * 100000, 10));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  useEffect(function () {
    var container = document.createElement('div');
    container.id = containerId.current;
    container.style.position = 'fixed';
    container.style.zIndex = zIndex;
    document.body.insertBefore(container, document.body.getElementsByTagName('script')[0]);
    setReady(true);
    disableScroll && (document.body.style.overflow = 'hidden');
    return function () {
      document.body.removeChild(container);
      disableScroll && (document.body.style.overflow = 'auto');
    };
  }, []);
  return ready && /*#__PURE__*/ReactDOM.createPortal(___EmotionJSX("div", _extends({}, className && {
    className: className
  }, {
    css: containerStyle(props)
  }, _omit(restProps, ['fixed', 'fullScreen']), {
    ref: ref
  }), children), document.getElementById(containerId.current));
});
BodyOverflow.propTypes = {
  children: PropTypes.any,
  zIndex: PropTypes.number,
  className: PropTypes.string,
  fullScreen: PropTypes.bool,
  fixed: PropTypes.bool,
  disableScroll: PropTypes.bool
};
export default BodyOverflow;